import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'
import { Backdrop, CircularProgress, Button } from '@material-ui/core'
import { GetApp } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  btn: {
    color: '#fff',
    background: '#B4CE75',
  }
}))

export default function Spinner() {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    // Spinner On
    setOpen(true)

    let category
    let sub_category

    // windowオブジェクト取得
    if (window.apicategory.category) {
      category = window.apicategory.category
    }

    if (window.apicategory.subcategory) {
      sub_category = window.apicategory.subcategory
    }

    // 音声ファイル（zip）ダウンロードURLにアクセス
    axios({
      url: 'https://materials.strail-english.jp/audios/downloads',
      method: 'get',
      params: { category, sub_category },
      responseType: 'blob'
    })
      .then(res => {
        // バイナリデータとして処理
        const blob = new Blob([res.data], {
          type: res.data.type
        })
        // aタグを作成してダウンロードを実行させる
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)

        // ダウンロードするzipファイル名をカテゴリ名に変更
        if (category) {
          if (sub_category) {
            link.setAttribute('download', sub_category + '.zip')
          } else {
            link.setAttribute('download', category + '.zip')
          }
        } else {
          link.setAttribute('download', 'audios.zip')
        }
        document.body.appendChild(link)
        link.click()

        // Spinner Off
        setOpen(false)
      })
      .catch(error => {
        setOpen(false)
        console.log(error)
      })
  }

  return (
    <>
      {window.apicategory.category === '速読Reading Advanced（YBM）' ? (
        <Button
          variant="contained"
          className={classes.btn}
          onClick={handleClick}
          startIcon={<GetApp />}
          disabled
        >
          DOWNLOAD ALL
        </Button>
      ) : (
        <Button
          variant="contained"
          className={classes.btn}
          onClick={handleClick}
          startIcon={<GetApp />}
        >
          DOWNLOAD ALL
        </Button>
      )}

      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  )
}

if (document.getElementById('spinner')) {
  ReactDOM.render(
    <Spinner />,
    document.getElementById('spinner')
  )
}